"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreDonutChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreDonutChart = /** @class */ (function (_super) {
    tslib_1.__extends(CoreDonutChart, _super);
    function CoreDonutChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreDonutChart.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "donut" }, this.props));
    };
    return CoreDonutChart;
}(react_1.default.PureComponent));
exports.CoreDonutChart = CoreDonutChart;
//# sourceMappingURL=CoreDonutChart.js.map